import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import clsx from 'clsx';
import { CheckIcon } from 'lucide-react';
import * as React from 'react';

function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root> & {
  className?: string;
}) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={clsx(
        'border-fx-neutral-400 data-[state=checked]:bg-fx-primary dark:data-[state=checked]:bg-fx-primary data-[state=checked]:border-fx-primary  peer h-4 w-4 shrink-0 rounded border bg-white outline-none transition-shadow focus-visible:ring  data-[state=checked]:text-white',
        'disabled:bg-fx-neutral-50 disabled:border-fx-neutral-200 disabled:cursor-not-allowed',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current transition-none"
      >
        <CheckIcon className="h-3.5 w-3.5" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
